import React from 'react';
import './PrivacyPolicy.css';

const Disclaimer = ({ language }) => {
  const content = {
    sq: {
      title: 'Disclaimer - Kufizimi i Përgjegjësisë',
      lastUpdated: 'Përditësuar më: 24 Shkurt 2026',
      sections: [
        {
          title: '1. Informacion i Përgjithshëm',
          content: 'Informacioni i paraqitur në këtë faqe është vetëm për qëllime informuese. Gjenerali SHPK bën përpjekje të arsyeshme për të siguruar saktësinë e informacionit, por nuk garanton plotësinë ose saktësinë e tij.'
        },
        {
          title: '2. Ofertat dhe Çmimet',
          content: `Të gjitha çmimet dhe ofertat në faqe:

• Janë VETËM orientuese
• NUK janë oferta të detyrueshme
• Mund të ndryshojnë pa njoftim paraprak
• Varen nga kushtet specifike të projektit
• Konfirmohen vetëm me kontratë të nënshkruar

Çmimi përfundimtar përcaktohet pas inspektimit të vendit dhe diskutimit të detajeve të projektit.`
        },
        {
          title: '3. Kohëzgjatja e Projekteve',
          content: `Afatet kohore të paraqitura:

• Janë vlerësime të përgjithshme
• Varen nga kompleksiteti i projektit
• Mund të ndikohen nga kushtet atmosferike
• Mund të ndikohen nga disponueshmëria e materialeve
• Konfirmohen vetëm në kontratë

Gjenerali SHPK nuk mban përgjegjësi për vonesa të shkaktuara nga faktorë jashtë kontrollit tonë.`
        },
        {
          title: '4. Fotot dhe Projektet',
          content: `Fotot e projekteve të paraqitura:

• Janë punë të realizuara nga Gjenerali SHPK
• Mund të kenë ndryshime nga projekti juaj
• Nuk garantojnë rezultate identike
• Përdoren vetëm për qëllime ilustruese

Çdo projekt është unik dhe rezultatet mund të ndryshojnë.`
        },
        {
          title: '5. Konsulenca dhe Këshilla',
          content: `Informacioni dhe këshillat e dhëna:

• Janë të përgjithshme dhe jo specifike
• Nuk zëvendësojnë konsulencë profesionale
• Nuk krijojnë marrëdhënie kontraktuale
• Duhet të verifikohen me profesionistë

Për këshilla specifike, kontaktoni drejtpërdrejt kompaninë.`
        },
        {
          title: '6. Linqe të Jashtme',
          content: `Faqja mund të përmbajë linqe të jashtme:

• Nuk kontrollojmë përmbajtjen e faqeve të tjera
• Nuk mbajmë përgjegjësi për faqet e tjera
• Linqet ofrohen vetëm për komoditet
• Përdorimi i tyre është në rrezikun tuaj

Rekomandojmë të lexoni kushtet e faqeve të tjera.`
        },
        {
          title: '7. Garancitë',
          content: `Gjenerali SHPK:

• NUK garanton rezultate specifike pa kontratë
• NUK garanton çmime pa inspektim
• NUK garanton kohë pa marrëveshje
• GARANTON cilësinë e punës sipas kontratës

Të gjitha garancitë specifikohen në kontratën e nënshkruar.`
        },
        {
          title: '8. Kufizimi i Dëmshpërblimit',
          content: `Në asnjë rast Gjenerali SHPK nuk mban përgjegjësi për:

• Dëme të tërthorta ose pasojore
• Humbje fitimi ose të ardhurash
• Humbje të dhënash ose informacioni
• Dëme të shkaktuara nga palë të treta

Përgjegjësia maksimale kufizohet në shumën e paguar për shërbimin.`
        },
        {
          title: '9. Ndryshimet në Faqe',
          content: `Gjenerali SHPK rezervon të drejtën:

• Të ndryshojë përmbajtjen e faqes në çdo kohë
• Të ndërpresë shërbimin për mirëmbajtje
• Të heqë ose shtojë shërbime
• Të përditësojë çmimet dhe ofertat

Ndryshimet bëhen pa njoftim paraprak.`
        },
        {
          title: '10. Përdorimi me Rrezik',
          content: `Përdorimi i kësaj faqe është:

• Me rrezikun tuaj
• Pa garanci të llojit "siç është"
• Pa garanci të përshtatshmërisë
• Pa garanci të saktësisë

Ju pranoni të përdorni faqen duke pranuar këto kushte.`
        },
        {
          title: '11. Kontakti për Sqarime',
          content: `Për çdo pyetje ose sqarim:

Email: altion.basha@gjenerali.al
Telefon: +355 68 209 1156
Adresa: Manëz, Durrës, Shqipëri

Jemi të gatshëm të sqarojmë çdo pikëpyetje dhe të ofrojmë informacion të detajuar.`
        }
      ]
    },
    en: {
      title: 'Disclaimer - Limitation of Liability',
      lastUpdated: 'Last Updated: February 24, 2026',
      sections: [
        {
          title: '1. General Information',
          content: 'The information presented on this website is for informational purposes only. Gjenerali SHPK makes reasonable efforts to ensure accuracy of information, but does not guarantee its completeness or accuracy.'
        },
        {
          title: '2. Quotes and Pricing',
          content: `All prices and quotes on the website:

• Are ONLY indicative
• Are NOT binding offers
• May change without prior notice
• Depend on specific project conditions
• Are confirmed only with signed contract

Final pricing is determined after site inspection and discussion of project details.`
        },
        {
          title: '3. Project Duration',
          content: `Timelines presented:

• Are general estimates
• Depend on project complexity
• May be affected by weather conditions
• May be affected by material availability
• Are confirmed only in contract

Gjenerali SHPK is not responsible for delays caused by factors beyond our control.`
        },
        {
          title: '4. Photos and Projects',
          content: `Project photos presented:

• Are work completed by Gjenerali SHPK
• May differ from your project
• Do not guarantee identical results
• Are used for illustrative purposes only

Every project is unique and results may vary.`
        },
        {
          title: '5. Consultation and Advice',
          content: `Information and advice provided:

• Are general and not specific
• Do not replace professional consultation
• Do not create contractual relationship
• Should be verified with professionals

For specific advice, contact the company directly.`
        },
        {
          title: '6. External Links',
          content: `The website may contain external links:

• We do not control content of other websites
• We are not responsible for other websites
• Links are provided for convenience only
• Use them at your own risk

We recommend reading terms of other websites.`
        },
        {
          title: '7. Warranties',
          content: `Gjenerali SHPK:

• Does NOT guarantee specific results without contract
• Does NOT guarantee prices without inspection
• Does NOT guarantee timelines without agreement
• GUARANTEES work quality per contract

All warranties are specified in the signed contract.`
        },
        {
          title: '8. Limitation of Damages',
          content: `In no event shall Gjenerali SHPK be liable for:

• Indirect or consequential damages
• Loss of profit or revenue
• Loss of data or information
• Damages caused by third parties

Maximum liability is limited to the amount paid for the service.`
        },
        {
          title: '9. Website Changes',
          content: `Gjenerali SHPK reserves the right to:

• Change website content at any time
• Suspend service for maintenance
• Remove or add services
• Update prices and offers

Changes are made without prior notice.`
        },
        {
          title: '10. Use at Risk',
          content: `Use of this website is:

• At your own risk
• Without warranty "as is"
• Without warranty of fitness
• Without warranty of accuracy

You agree to use the website accepting these conditions.`
        },
        {
          title: '11. Contact for Clarification',
          content: `For any questions or clarification:

Email: altion.basha@gjenerali.al
Phone: +355 68 209 1156
Address: Manëz, Durres, Albania

We are ready to clarify any questions and provide detailed information.`
        }
      ]
    }
  };

  const text = content[language] || content.sq;

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>{text.title}</h1>
        <p className="last-updated">{text.lastUpdated}</p>
        
        {text.sections.map((section, index) => (
          <div key={index} className="privacy-section">
            <h2>{section.title}</h2>
            <p style={{ whiteSpace: 'pre-line' }}>{section.content}</p>
          </div>
        ))}

        <div className="privacy-footer">
          <p>© 2026 Gjenerali SHPK. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
